import { render, staticRenderFns } from "./MentorSettings.vue?vue&type=template&id=83d1dc44&"
import script from "./MentorSettings.vue?vue&type=script&lang=js&"
export * from "./MentorSettings.vue?vue&type=script&lang=js&"
import style0 from "./MentorSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports